var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table is-narrow is-fullwidth is-marginless" },
    [
      _c("tbody", [
        _c("tr", [
          _c("th", [_vm._v("Peso del documento")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.readableSizeFile(_vm.documento.peso)))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Versión")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.documento.ultima_version.orden + 1) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Ruta")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.documento.ruta))]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Fecha creación")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(
                _vm._f("moment")(
                  new Date(_vm.documento.created_at),
                  "dddd, DD/MM/YYYY, HH:mm:ss"
                )
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v("Aspectos asignados")]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "field is-grouped is-grouped-multiline" },
              [
                _vm._l(_vm.documento.aspectos, function (asp) {
                  return _c(
                    "div",
                    { key: `info-aspecto-${asp.id}`, staticClass: "control" },
                    [
                      _c("div", { staticClass: "tags has-addons" }, [
                        _c("span", { staticClass: "tag is-primary" }, [
                          _vm._v(_vm._s(asp.nombre)),
                        ]),
                        _vm._v(" "),
                        _vm.canAsignarAspectos
                          ? _c("a", {
                              staticClass: "tag is-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.quitarAspecto(asp)
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.canDeleteAspectos &&
                _vm.documento.aspectos.length < _vm.todosLosAspectos.length
                  ? _c("div", { staticClass: "control" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button tag is-primary is-light",
                          on: { click: _vm.openAsignarAspecto },
                        },
                        [_c("i", { staticClass: "fas fa-plus" })]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }